import forge from "node-forge";

export function encryptBankDetailsFrontend(
  data: object,
  publicKey: string,
): string {
  try {
    const forgePublicKey = forge.pki.publicKeyFromPem(publicKey);
    const dataString = JSON.stringify(data);

    // Adjust encryption to use SHA-1 for hashing and MGF1
    const encrypted = forgePublicKey.encrypt(dataString, "RSA-OAEP", {
      md: forge.md.sha1.create(), // Match backend SHA-1
      mgf1: {
        md: forge.md.sha1.create(), // Match MGF1 SHA-1
      },
    });

    return forge.util.encode64(encrypted);
  } catch (error) {
    console.error("Error encrypting data:", error);
    throw error;
  }
}
